module.exports = __webpack_public_path__ + "static/media/Levin_Range_Seat_1.7917ee5b.jpg";